
import React from "react";
import { CalendarCheck2, Lightbulb } from "lucide-react";

import InnovationHubHeader from "../components/InnovationHubHeader";
import InnovationHubFooter from "../components/InnovationHubFooter";

export default function ApplicationClosedPage() {
  return (
    <main className="flex min-h-screen flex-col bg-[#eef5ff]">
      <InnovationHubHeader />

      <section className="flex flex-1 items-center justify-center px-4 py-12 sm:px-6 sm:py-20">
        <div className="w-full max-w-2xl rounded-3xl bg-white px-6 py-12 text-center shadow-sm sm:px-12 sm:py-16">

          <div className="mx-auto mb-7 flex h-20 w-20 items-center justify-center rounded-full bg-[#e8f2ff]">
            <CalendarCheck2
              size={38}
              className="text-[#1565C0]"
              strokeWidth={1.7}
            />
          </div>

          <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-[#eef5ff] px-4 py-2 text-sm font-semibold text-[#1565C0]">
            <Lightbulb size={16} />
            2026–2027 Eğitim Öğretim Yılı
          </div>

          <h1 className="text-2xl font-bold leading-snug text-[#173b7a] sm:text-3xl">
            Başvuru Süreci Sona Ermiştir
          </h1>

          <div className="mx-auto my-7 h-1 w-16 rounded-full bg-[#1565C0]" />

          <p className="mx-auto max-w-lg text-base leading-8 text-gray-600 sm:text-lg">
            2026-2027 yılı başvuru süreci sona ermiştir.
            Fikirleri ile başvuruda bulunan tüm girişimcilere
            teşekkür ederiz.
          </p>

        </div>
      </section>

      <InnovationHubFooter />
    </main>
  );
}
